import { Button, Divider, Drawer, Form, Input, message, Space } from 'antd';
import React, { useContext, useEffect } from 'react';
import Markdown from 'react-markdown';
import Card from 'antd/es/card/Card';
import remarkDirective from 'remark-directive';
import remarkDirectiveSugar from 'remark-directive-sugar';
import { usePageServicePutBackendv2Page } from '../../backendapi/queries';
import { PageDto } from '../../backendapi/requests';
import { ConfigContext } from '../../contexts/ConfigContext';

const EditPage: React.FC<{ page?: PageDto, isOpen: boolean, onClose: () => void }> = ({ page, isOpen, onClose }) => {

    const { currentClient } = useContext(ConfigContext)
    const {mutateAsync: updatePage, isPending, isSuccess, isError, error } = usePageServicePutBackendv2Page();

    const [form] = Form.useForm<PageDto>();
    const [messageApi, contextHolder] = message.useMessage();
    const content = Form.useWatch('content', form);

    const onSubmit = () => {
        form.submit();
    }

    const onFinish = async () => {
        if (page) {
            const values = form.getFieldsValue(true) as PageDto;
            values.clientId = currentClient.id;
            await updatePage({key: page.id, requestBody: values});
        }
    };

    useEffect(() => {
        if (page) {
            form.setFieldsValue(page);
        }
    }, [page, form]);

    useEffect(() => {
        if(isSuccess){
            messageApi.success("Page updated");
            onClose();
        }
    }, [isSuccess, messageApi, onClose]);

    useEffect(() => {
        if(isError){
            messageApi.error(error?.toString());
        }
    }, [error, isError, isSuccess, messageApi]);

    return (
        <>
            {contextHolder}

            <Drawer
                title={`Edit ${page?.name}`}
                size={1200}
                onClose={onClose}
                open={isOpen}
                extra={
                    <Space>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button onClick={onSubmit} type="primary" loading={isPending}>
                            Submit
                        </Button>
                    </Space>
                }
            >
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}>

                    <Form.Item rules={[{ required: true }]} name='name' label="Name">
                        <Input />
                    </Form.Item>

                    <Form.Item rules={[{required: true}]} name='content' label="Content">
                        <Input.TextArea rows={16} />
                    </Form.Item>

                    <h3>Preview</h3>
                    <Divider />

                    <Card>
                        <div id="createapp" style={{maxHeight: 500, minHeight: 0, overflow: 'auto'}}>
                            <div className='page-wrapper'>
                                <Markdown remarkPlugins={[remarkDirective, remarkDirectiveSugar]}>{content}</Markdown>
                            </div>
                        </div>
                    </Card>
                </Form>
            </Drawer>
        </>

    );
};

export default EditPage;